import { Box, Button, Grid, Link, Typography } from "@material-ui/core";
import { TextField } from 'mui-rff';
import {validateEmail } from '../../utils/validators'


const validate = values => {
    const errors = {};

    if (!validateEmail(values.userName)) {
        errors.userName = 'Please enter a valid email address';
    }
    if (!values.userPassword) {
        errors.userPassword = 'Required';
    }
    return errors;
};


export const LoginMetadataBuilder = () => (new _LoginMetadataBuilder());
 class _LoginMetadataBuilder {

    constructor() {
        this.inputs = {
            onSubmitFunction: () => { },
            onShowRegistrationClick: () => { },
            onShowForgotPasswordClick: () => { },
            onShowChangePasswordClick: () => { },
            errorMessage: ''
        }

        //dynamically generating setters for inputs in constructor
        Object.keys(this.inputs).forEach(input => {
            // if booleanValue, it will have the property name became has
            let functionNameValue = (typeof this.inputs[input] == "boolean") ?
                `has${input.charAt(0).toUpperCase() + input.slice(1)}` :
                `with${input.charAt(0).toUpperCase() + input.slice(1)}`;

            this[`${functionNameValue}`] = (value) => {
                this.inputs[`${input}`] = value;
                return this;
            }
        })
    }

    build() {
        return (
            LoginMetadata(this.inputs.onSubmitFunction, this.inputs.onShowRegistrationClick, this.inputs.onShowForgotPasswordClick, this.inputs.errorMessage)
        )
    }
}

export const LoginMetadata = (onSubmitFunction, onShowRegistrationClick, onShowForgotPasswordClick, errorMessage) => {
    return (
        {
            onSubmit: onSubmitFunction,
            validateFunction: validate,

            sections: [
                {
                    uiComponent: Grid,
                    props: {
                        id: "loginIntoYourAccount",
                        className: "login_into_your_account",
                        container: true,
                        alignItems: "center",
                        spacing: 2
                    },

                    elements: [
                        {
                            size: 12,
                            uiComponent:Typography,
                            props: {
                                text: errorMessage,
                                className: errorMessage ? 'error-message' : 'hidden-error-message',
                                children: errorMessage
                            }
                        },
                        {
                            size: 6,
                            uiComponent: Typography,
                            props: {
                                text: "Log in and pick up where you left off.",
                                children: "Log in and pick up where you left off.",
                                className: "headline"
                            }
                        },
                        {
                            size: 6,
                            uiComponent: Box,
                            props: {
                                className: "dont_have_account",
                                children: (
                                    <span>
                                        Don't have an account? <Link aria-label="Sign up for a new account" className="cta_signup" onClick={onShowRegistrationClick}> Sign Up</Link>
                                    </span>
                                ),
                            }
                        },
                        {
                            size: 6,
                            uiComponent: TextField,
                            props: {
                                type: "text",
                                label: "Email addresss",
                                placeholder: "",
                                InputLabelProps: { shrink: true },
                                name: "userName"
                            }
                        },
                        {
                            size: 6,
                            uiComponent: TextField,
                            props: {
                                type: "password",
                                label: "Password",
                                placeholder: "",
                                name: "userPassword"
                            }
                        },
                        {
                            size: 6,
                            uiComponent: Button,
                            props: {
                                type: "submit",
                                variant: "contained",
                                children: "Log in",
                            }
                        },
                        {
                            size: 6,
                            uiComponent: Link,
                            props: {
                                className: "forgot_password",
                                children: "Forgot password?",
                                onClick: () => {
                                    onShowForgotPasswordClick();
                                }
                            }
                        }
                    ]
                }
            ]
        }

    )
}
